import React from 'react';
import styled from 'styled-components';
import RakutenLargeLogo from '../../../../../app/common/logos/RakutenLargeLogo';
import KoboLogo from '../../../../../app/common/logos/KoboLogo';
import RakutenTVLogo from '../../../../../app/common/logos/RakutenTVLogo';
import ViberLogo from '../../../../../app/common/logos/ViberLogo';
import { COLORS, SPACINGS } from '../../../../../app/common/constants/styles';
import { TranslationHelpers } from '../../../../../i18n/translationHelpers';
import { IHistoryEntry } from '../../redux/rewardsTransactionsHistory.service';

const Header = styled.div`
    color: ${COLORS.grey7};
    flex: 2;
    text-align: left;
    padding: ${SPACINGS.base}px 0;
    font-size: 0.8125rem;
    padding-right: 10px;
`;

const AccordionText = styled.div`
    padding: ${SPACINGS.base}px 0;
    flex: 2;
    text-align: left;
    font-size: 0.8125rem;
    &.earned {
        color: ${COLORS.green};
    }
    &.spent {
        color: ${COLORS.rakutenRed};
    }
`;

const AccordionSection = styled.div`
    display: flex;
    padding: ${SPACINGS.base}px 10;
    margin: ${SPACINGS.base}px 10;
`;

const AccordionLogo = styled.div`
    padding: ${SPACINGS.base}px 0;
    text-align: left;
    flex: 2;
    span {
        line-height: 1.5;
    }
    svg {
        height: 16px;
    }

    &.logo-rakuten svg {
        width: 70px;
    }

    &.logo-tv svg {
        width: 93px;
    }

    &.logo-viber svg {
        width: 115px;
    }

    &.logo-kobo svg {
        width: 107px;
    }
`;

class TransactionAccordionInfo extends React.Component<{
    transaction: IHistoryEntry;
    type: string;
}> {
    render() {
        const {
            transaction: { orderNo, action, logo },
            type,
        } = this.props;
        return (
            <div>
                <AccordionSection>
                    <Header>{TranslationHelpers.getFormattedMessage('points.earned.spent')}</Header>
                    {action === 'GRANT' ? (
                        <AccordionText className={'earned'}>
                            {TranslationHelpers.getFormattedMessage('points.earned')}
                        </AccordionText>
                    ) : (
                        <AccordionText className={'spent'}>
                            {TranslationHelpers.getFormattedMessage('points.spent')}
                        </AccordionText>
                    )}
                </AccordionSection>
                <AccordionSection>
                    <Header>{TranslationHelpers.getFormattedMessage('points.type')}</Header>
                    <AccordionText>
                        {type === 'standard'
                            ? TranslationHelpers.getFormattedMessage('points.standard')
                            : TranslationHelpers.getFormattedMessage('points.expiring')}
                    </AccordionText>
                </AccordionSection>
                <AccordionSection>
                    <Header>{TranslationHelpers.getFormattedMessage('points.order.number')}</Header>
                    <AccordionText> {orderNo} </AccordionText>
                </AccordionSection>
                <AccordionSection>
                    <Header>{TranslationHelpers.getFormattedMessage('points.service')}</Header>
                    <AccordionLogo>
                        {logo === 'rakuten' ? (
                            <RakutenLargeLogo />
                        ) : logo === 'tv' ? (
                            <RakutenTVLogo />
                        ) : logo === 'viber' ? (
                            <ViberLogo />
                        ) : logo === 'kobo' ? (
                            <KoboLogo />
                        ) : (
                            <RakutenLargeLogo />
                        )}{' '}
                    </AccordionLogo>
                </AccordionSection>
            </div>
        );
    }
}

export default TransactionAccordionInfo;
